import { Plus } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { OutlinedPrimaryButton } from "src/components/Default/LekUI/Button";
import { FlashcardsTipTapEditor } from "src/components/TipTapEditor/FlashcardsTipTapEditor";

function AddFlashcardOptionView({ onAdd, onClose, flashcard, onSuccess }) {
	const { t } = useTranslation();
	const [front, setFront] = useState("");
	const [back, setBack] = useState("");
	const [resetKey, setResetKey] = useState(0);

	useEffect(() => {
		if (flashcard) {
			setFront(flashcard.front);
			setBack(flashcard.back);
		} else {
			setFront("");
			setBack("");
		}
		setResetKey((prev) => prev + 1);
	}, [flashcard]);

	const isEmpty = (html) => {
		if (!html) return true;
		if (/<img\s/i.test(html)) return false;
		const stripped = html.replace(/<[^>]*>/g, "").trim();
		return stripped.length === 0;
	};

	const onClick = async () => {
		if (isEmpty(front) || isEmpty(back)) {
			toast.warning(t("errors.emptyFlashcards"), {
				position: toast.POSITION.BOTTOM_LEFT,
				pauseOnHover: false,
				autoClose: 3000,
			});
			return;
		}
		await onAdd({ front, back });
		setFront("");
		setBack("");
		setResetKey((prev) => prev + 1);
		onClose?.();
		onSuccess?.();
	};

	const getText = () => {
		return flashcard
			? t("commands.edit")
			: t("creators.decks.addToDeck", "Dodaj do zestawu");
	};

	return (
		<div className="flashcard--deck--add-new-flashcard--container">
			<div className="flashcard--deck--add-new-flashcard">
				<FlashcardsTipTapEditor
					key={`front-${resetKey}`}
					className="flashcard--tiptap-editor"
					initialHtml={front}
					onUpdate={setFront}
					placeholder={t("decks.front")}
					data-test-id="flashcard-front-editor"
				/>
				<FlashcardsTipTapEditor
					key={`back-${resetKey}`}
					className="flashcard--tiptap-editor"
					initialHtml={back}
					onUpdate={setBack}
					placeholder={t("decks.back")}
					data-test-id="flashcard-back-editor"
				/>
			</div>
			<div className="flashcard--deck--add-new-flashcard--footer flex items-center mt-12 gap-8">
				{onClose && (
					<button type="button" className="link-button" onClick={onClose}>
						{t("commands.cancel")}
					</button>
				)}
				<OutlinedPrimaryButton className="flex-center-row w-100" onClick={onClick} data-test-id="flashcard-add-submit-button">
					<Plus className="icon-super-small" />
					<span className="size-16-light">{getText()}</span>
				</OutlinedPrimaryButton>
			</div>
		</div>
	);
}

export default AddFlashcardOptionView;
